<template>
  <div>
      <!--Header Components-->
      <base-header class="pb-6" type="">
        <b-row class="align-items-center py-4">
          <b-col lg="12" cols="12">
            <!-- <h6 class="h2 text-white d-inline-block mb-0">{{$route.name}}</h6> -->
            <h6 class="h2 d-inline-block mb-0">{{language_terms[$route.name]}}</h6>
            <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
              <route-breadcrumb/>
            </nav>
          </b-col>
        </b-row>
      </base-header>
    <b-container fluid class="mt--6">
       <div>
            <loading :active.sync="loading" 
              color= '#007bff'
              :width= '128'
              :height= '128'
              loader='dots'
              :can-cancel="true" 
              :is-full-page="true">
            </loading>
        </div>
        <b-row>
            <b-col sm="12">
                <div class="card-wrapper">
                    <b-card>
                        <div slot="header" class="mb-0">
                            <b-row>
                                <b-col md="8">
                                    <h3>{{language_terms['QUICK_SEARCH']}}</h3>
                                </b-col>
                                 <b-col md="4">
                                    <base-button type="success" @click="newStockIn" class="float-right">
                                        <i class="fa fa-plus"></i>
                                    </base-button>
                                 </b-col>

                            </b-row>
                        </div>
                        <b-row>
                            <b-col md="3" >
                                <base-input :label="language_terms['QUICK_FILTER']" v-model="filter.keyword" v-on:keyup.enter="clickOnSearch">
                                </base-input>
                            </b-col>
                            <b-col md="2">
                              <base-input :label="language_terms['TYPE']">
                                <el-select v-model="filter.type" filterable :placeholder="language_terms['TYPE']">
                                    <el-option
                                        v-for="option in typeOptions"
                                        :key="option.code"
                                        :label="language_terms[option.name]"
                                        :value="option.code">
                                    </el-option>
                                </el-select>
                                </base-input>
                            </b-col>
                            <b-col md="2">
                              <base-input :label="language_terms['DATE_FROM']" >
                                <flat-picker
                                    slot-scope="{ focus, blur }"
                                    @on-open="focus"
                                    @on-close="blur"
                                    style="background-color: white"
                                    class="form-control datepicker"
                                    v-model="filter.date_from">
                                </flat-picker>
                              </base-input>
                            </b-col>
                            <b-col md="2">
                              <base-input :label="language_terms['DATE_TO']" >
                                <flat-picker
                                    slot-scope="{ focus, blur }"
                                    @on-open="focus"
                                    @on-close="blur"
                                    style="background-color: white"
                                    class="form-control datepicker"
                                    v-model="filter.date_to">
                                </flat-picker>
                              </base-input>
                            </b-col>
                            <b-col md="2">
                                <base-input :label="language_terms['DIRECTION']">
                                <el-select
                                    v-model="filter.direction"
                                    filterable
                                    :placeholder="language_terms['DIRECTION']"
                                    >
                                    <el-option
                                        v-for="option in directionOptions"
                                        :key="option.code"
                                        :label="language_terms[option.name]"
                                        :value="option.code">
                                    </el-option>
                                </el-select>
                                </base-input>
                            </b-col>
                            <b-col cols="1" class="mt-4">
                              <base-button type="primary" @click="clickOnSearch" class="mt-2">{{language_terms['SEARCH']}}</base-button>
                          </b-col>
                        </b-row>
                    </b-card>
                    <PaginatedTables :myColumns="tableColumns" :tableData="items" :cardTitle="language_terms['SEARCH_RESULTS']" v-if="items.length > 0"/>

                </div>
            </b-col>
        </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css'; 

import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Select, Option } from "element-ui";

import PaginatedTables from '@/views/Tables/PaginatedTables'

export default {
  components: {
    Loading,
    flatPicker,
    [Select.name]: Select,
    [Option.name]: Option,
    PaginatedTables
  },
  data() {
    return {
      directionOptions:[
        {code:"ALL", name:"ALL"},
        {code:"IN", name:"STOCK_IN"},
        {code:"OUT", name:"STOCK_OUT"}
      ],
      typeOptions:[
        {code:"ADJUSTMENT", name:"ADJUSTMENT"},
        {code:"DO_SO", name:"DO_FROM_SO"},
        {code:"DO", name:"DELIVERY_ORDER"},
        {code:"GRN", name:"GOOD_RECEIVE_NOTE"},
        {code:"GRN_PO", name:"GRN_FROM_PO"},
        {code:"STOCKTRANSFER", name:"STOCKTRANSFER"}
      ],
      loading:false,
      filter:{
        keyword:"",
        date_from:null,
        date_to:null,
        direction:'ALL',
        type:'ADJUSTMENT'
      },
      tableColumns: [
        {
          prop: "code",
          label: "Code",
          minWidth: 100,
          sortable: true,
          key:"CODE"
        },
        {
          prop: "movement_date",
          label: "MOVEMENT_DATE",
          minWidth: 120,
          sortable: true,
          key:"MOVEMENT_DATE"
        },
        {
          prop: "reference_code",
          label: "REFERENCE",
          minWidth: 120,
          sortable: true,
          key:"REFERENCE"
        },
        {
          prop: "type",
          label: "TYPE",
          minWidth: 120,
          sortable: true,
          key:"TYPE"
        },
        {
          prop: "direction",
          label: "DIRECTION",
          minWidth: 80,
          sortable: true,
          key:"DIRECTION"
        },
        {
          prop: "time_created",
          label: "TIME_CREATED",
          minWidth: 100,
          sortable: true,
          key:"TIME_CREATED"
        },
      ]
    };
  },
  mounted(){
    this.updateTableLang()
  },

  computed:{
    ...mapState({
      language_terms:(state)=>state.languages.language_terms,
      items:(state) => state.stockcards.stockcards
    })
  },

  watch:{
    language_terms:{
            handler(val){
                this.updateTableLang()
            },
        }
  },
  methods:{
      async clickOnSearch()
      {
        await this.$store.dispatch("stockcards/quickSearch", this.filter);
      },
      newStockIn()
      {
          this.$router.push("/inventory/stock-in")
      },
      newStockOut()
      {
          this.$router.push("/inventory/stock-out")
      },
      updateTableLang(){
      for(let i=0; i<this.tableColumns.length;i++){
         let key = this.tableColumns[i].key
         this.tableColumns[i].label = this.language_terms[key]

      }
    },

  }
};
</script>


<style>
</style>